export default "__VITE_ASSET__BCLN7nVV__"